import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import campaignService from "@/services/campaign.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveCampaignReturn = {
  removeCampaign: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCampaign = (): UseRemoveCampaignReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove: removeCampaign,
  } = useRemove({
    operation: (campaignId) => campaignService.delete(campaignId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removeCampaign,
  };
};

export default useRemoveCampaign;
